import React, { useEffect, useState, useContext, useRef } from 'react';


function SvgHLine({id, x, y, x2 }) {

    return (<svg id={id} xmlns="http://www.w3.org/2000/svg">
        <defs>
            <filter id={"glow" + id} x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="5" result="blur" />
                <feFlood floodColor="#32CD32" floodOpacity="0.5" result="glowColor" />
                <feComposite in="glowColor" in2="blur" operator="in" result="coloredBlur" />
                <feMerge>
                    <feMergeNode in="coloredBlur" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>

        <path id={"motionPath" + id} d={`M${x} ${y} L${x2} ${y}`} fill="none" stroke="lightgray" strokeWidth="3" strokeLinecap='round'  />

        <circle cx="0" cy="0" r="4" fill="#1d80b5" filter={"url(#glow" + id + ")"}>
            <animateMotion dur="3s" repeatCount="indefinite">
                <mpath href={"#motionPath" + id} />
            </animateMotion>
        </circle>
    </svg>)
}

export default SvgHLine